import React from "react";
import Brands from "../common/Brands/Brands";
import Footer from "../common/Footer/Footer";
import FooterThree from "../common/Footer/FooterThree";
import FullScreenBtn from "../common/FullScreenBtn";
import Menu from "../common/Menu/Menu";
import Team from "../common/Team/Team";
import Testimonial from "../common/Testimonial/Testimonial";
import AboutThree from "./AboutThree";
import BlogThree from "./BlogThree";
import CategoryThree from "./CategoryThree";
import ContactThree from "./ContactThree";
import PortfolioThree from "./PortfolioThree";
import Promotion from "./Promotion";
import SliderHomeThree from "./SliderHomeThree";
import TopCtaArea from "../Home/TopCtaArea";
import Gallery from "../Home/Gallery";

const HomeThree = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <SliderHomeThree />
      <AboutThree />
      <CategoryThree />
      <FullScreenBtn />
      <PortfolioThree />
      <Promotion />
      {/* <Team />
      <Testimonial />
      <Brands />
      <BlogThree /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: "30px",
          marginTop: "5rem",
          marginBottom: "5rem",
          textAlign: "center",
        }}
      >
        <p>Explore Our Journey</p>
        <h2 className="">Our Gallery</h2>
        <h4>Discover the Moments, People, and Work That Shape Who We Are</h4>
      </div>
      <Gallery />
      <div
        style={{
          marginTop: "5rem",
        }}
      ></div>
      <ContactThree />

      <FooterThree />
    </>
  );
};

export default HomeThree;
